import { GearUiAdminConfigType } from '../../Model/uiAdminConfig/GearUiAdminConfigType';

export const uiAdminConfigsKeys = {
  all: ['uiAdminConfigs'] as const,
  uiAdminConfigByKey: (key?: GearUiAdminConfigType) => [...uiAdminConfigsKeys.all, 'entry', key] as const,
  uiAdminConfigWritePermissions: (keys?: string[]) => [...uiAdminConfigsKeys.all, 'writePermissions', keys] as const
};
